import { Button, Input, Space } from "antd";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

interface PaddleProductToolbarProps {
  onSearch: (value: string) => void;
}

const PaddleProductToolbar = ({ onSearch }: PaddleProductToolbarProps) => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");

  const handleAddProduct = () => {
    navigate("/payment-products/add");
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    onSearch(value);
  };

  return (
    <div className="paddle-products-toolbar">
      <div className="paddle-products-heading-container">
        <h2 className="paddle-products-heading">Paddle Products</h2>
        <div className="paddle-products-search-container">
          <Input
            placeholder="Search products..."
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => handleSearch(e.target.value)}
            style={{ width: 300 }}
            allowClear
          />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAddProduct}
            className="add-paddle-product-button"
          >
            Create Product
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaddleProductToolbar;

